import gql from 'graphql-tag'

const initShopStatistics = gql`
	query initShopStatistics($params: StatisticShopParams!) {
		cashAssist {
			initShopStatistics(params: $params)
		}
	}
`

export default initShopStatistics
